class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    if(this.detailsContainer){
        this.detailsContainer.addEventListener(
          'keyup',
          (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    
        );
    }
    if(this.summaryToggle){
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
      this.summaryToggle.setAttribute('role', 'button');
    }
    if(this.querySelector('button[type="button"]')){
        this.querySelector('button[type="button"]').addEventListener(
          'click',
          this.close.bind(this)
        );
    }
    if(this.querySelector('button[type="reset"]')){
      this.querySelector('button[type="reset"]').addEventListener(
        'click',
        this.reset.bind(this)
      );
    }



  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    if (!this.detailsContainer) return; // 安全防止空引用
  
    setScrollbarWidth();
    setHeaderBottomPosition();
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
  
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');
  
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
    console.log('打开搜索弹窗');
  
    $('.template-search__search').css('opacity', 0);
  
    if ($('.has-recommendation .search__input').attr('placeholder') && $('.has-recommendation .search__input').val() === '') {
      console.log('placeholder 显示');
      $('.has-recommendation_bottom').addClass('has_placehoder').removeClass('no_placehoder');
    }
  }

  // open() {
  //   setScrollbarWidth();
  //   setHeaderBottomPosition();
    
  //   this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
  //   this.detailsContainer.setAttribute('open', true);
  //   document.body.addEventListener('click', this.onBodyClickEvent);
  //   document.body.classList.add('search-modal--open');

  //   trapFocus(
  //     this.detailsContainer.querySelector('[tabindex="-1"]'),
  //     this.detailsContainer.querySelector('input:not([type="hidden"])')
  //   );
  //   console.log('打开搜索弹窗');
  //   $('.template-search__search').css('opacity',0);
  //   // 判断是否显示placehoder
  //   if($('.has-recommendation .search__input').attr('placeholder') && $('.has-recommendation .search__input').val() === '') {
  //     console.log('placeholder 显示');
  //     $('.has-recommendation_bottom').addClass('has_placehoder').removeClass('no_placehoder');
  //   }
  // }

  close() {
    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    this.querySelector('input[type="search"]').value = '';
    console.log('点击清除');
    $('.has-recommendation_bottom').addClass('has_placehoder').removeClass('no_placehoder');
  }
}

customElements.define('search-modal', SearchModal);
